import './account_mapping'
import './account-mapping-subheader'
import setupDeleteReconciliationDetails from './delete-reconciliation-details'
import './accounts-rounding-configuration'
import './account-entries'
import './account-trend-chart'
import './accounts/edit-modal-form'
import './adjustments'
import './check-lists'
import './company-consolidation-settings-modal'
import './company-users'
import './company-users-v2'
import './details'
import './diff'
import './edit-partner-segment'
import './import_ledger_form'
import './insights-drawer'
import './insights-floating-sidepane'
import './insights-right-drawer'
import './insights-sidepane-toggle'
import './insights-subnav-left'
import './insights-subnav-right'
import setupLogRocket from './setup-log-rocket'
import setupReloadOTPBanner from './setup-reload-otbanner'
import setupAppcues from './setup-appcues'
import setupAppcuesThroughSegment from './setup-appcues-through-segment'
import './manual-ledger-upload'
import setupRemarkTags from './setup-remark-tags'
import './set-current-ledger'
import setupAccordion from './setup-accordion'
import setupAdjustmentImports from './setup-adjustment-imports'
import setupAdministrationSyncEntities from './setup-administration-sync-entities'
import setupTurbolinksNavigationFixes from './setup-turbolinks-navigation-fixes'
import setupCompaniesRecentlyVisited from './companies-recently-visited'
import setupAsyncRenderError from './templates-async-render-error.ts'
import setupFlameGraph from './flame-graph'
import setupAdjustmentLink from './setup-adjustment-link'
import setupQuickAddAdjustment from './setup-quick-add-adjustment'
import './toggle_adjustments_table'
import './select-retained-earnings-account'
import './auto-reload-page'
import './workflow-statuses-reorder'
import './wait-for-mum'
import './period-specific-documents'
import './audit-log-show-more'
import setupAdvancedOption from './setup-sync-advanced-option'
import './admin-bulk-lock-ledgers'
import './admin-migrate-mapping-list-progress'
import './shared-template-configurations'
import './share-trigger'
import './share-trigger-mode'
import setupReconciliationProposal from './setup-reconciliation-proposal'
import setupFixedTableHeaders from './fixed-table-headers'
import setupValidateRequiredFields from './validate-required-fields'
import setupDrawers from './setup-drawers'
import setupSearchInput from './setup-search-input'
import './navbar-color'
import './back-in-context'
import './nav-abort-controllers'

setupDeleteReconciliationDetails()
setupAdvancedOption()
setupLogRocket()
setupReloadOTPBanner()
setupAppcues()
setupAppcuesThroughSegment()

setupAccordion()
setupAdjustmentImports()
setupAdministrationSyncEntities()

setupDrawers()

setupAdjustmentLink()
setupQuickAddAdjustment()

setupReconciliationProposal()

setupFixedTableHeaders()

setupRemarkTags()

setupSearchInput()

setupTurbolinksNavigationFixes()
setupValidateRequiredFields()

setupCompaniesRecentlyVisited()

setupAsyncRenderError()

setupFlameGraph()

// DOMAINS
import '@app/application/budget/behaviors'
import '@app/application/client_meetings/behaviors'
import '@app/application/communication/behaviors'
import '@app/application/ai_ocr_requests/behaviors'
import '@app/application/document/behaviors'
import '@app/application/export/behaviors'
import '@app/application/layout/behaviors'
import '@app/application/marketplace/behaviors'
import '@app/application/miscellaneous/behaviors'
import '@app/application/reconciliation/behaviors'
import '@app/application/reconciliation_proposal/behaviors'
import '@app/application/report/behaviors'
import '@app/application/report-template/behaviors'
import setupReportEditor from '@app/application/report/behaviors/setup-report-editor'
import '@app/application/workflow-list-navigation/behaviors'
import '@app/application/workflow-overview-navigation/behaviors'
import '@app/application/workflows/behaviors'
import '@app/application/pulse/behaviors'
import '@app/application/invoices/behaviors'
import '@app/application/ledger-audit-log/behaviors'
import '@app/application/sf-assistant-checks/behaviors'
import '@app/application/accounts/behaviors'
import '@app/application/wall-clock-time/behaviors'
import '@app/application/company_links/behaviors'
import { exposeGlobally } from '@app/application/report/handlers/sf-entries-mounter'

// Users
import './users/configure/email-notifications-form'
import './users/configure/enforce-sso-access-form'
import './users/user-management-tabs'
import './users/user-select'

import './client-type-form'
import './firm-template-modal'

setupReportEditor()
onDomLoad(() => {
  exposeGlobally()
})
